import React, { Component } from "react";
import { Link } from "react-router-dom";
import data from "../../src/data/mainData.json"

class BankingPartners extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let banks = data?.banking_partners || [];

    return (
      <div className="ltn__brand-logo-area ltn__brand-logo-1 section-bg-1 pt-80 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-title">Our Banking Partners</h2>
            </div>
          </div>

          <div className="row justify-content-center mt-40">
            {banks.map((bank, index) => (
              <div key={index} className="col-lg-2 col-md-3 col-6 text-center mb-30">
                <a
                  href={bank.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={bank.logo}
                    alt={bank.name}
                    style={{
                      maxWidth: "120px",
                      height: "auto",
                      objectFit: "contain"
                    }}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default BankingPartners;
